"use client"

import Image from 'next/image'
import Link from 'next/link'

interface CategoryCardProps {
  title: string
  image: string
  href: string
}

export function CategoryCard({ title, image, href }: CategoryCardProps) {
  return (
    <Link href={href} className="flex flex-col items-center">  
        <div className="w-[76px] h-[76px] md:w-[200px] md:h-[200px] bg-primary rounded-xl overflow-hidden mb-2">
          <Image
            src={`${image}?w=76&h=76`}
            alt={title}
            width={76}
            height={76}
            className="object-cover size-full"
          />
        </div>
        <span className="text-center text-xs md:text-sm">{title}</span>
    </Link>
  )
}